import React from "react";
import * as Icons from "react-feather";
import { Tag } from "component/shared/tag";

// v4 card chip vocabulary: integrations with a live connection show "Connected";
// integrations that are simply configured show "Enabled"; error state is "Connection Lost".
// Rendered with the design-system Tag (32px pill, 8px 16px padding, Figma tag palette).

export const enabledChip = (
	<Tag label="Enabled" variant="success" icon={<Icons.Check size={16} />} />
);

export const connectedChip = (
	<Tag label="Connected" variant="success" icon={<Icons.Check size={16} />} />
);

export const connectionLostChip = (
	<Tag label="Connection Lost" variant="error" icon={<Icons.AlertTriangle size={16} />} />
);
